export default {
  CODE852: "+852 香港",
  CODE853: "+853 澳門",
  CODE86: "+86 中國内地",
  CODE886: "+886 台灣",
  CODE1: "+1 北美洲",
  CODE7: "+7 俄羅斯",
  CODE20: "+20 埃及",
  CODE27: "+27 南非",
  CODE30: "+30 希臘",
  CODE31: "+31 荷蘭",
  CODE32: "+32 比利時",
  CODE33: "+33 法國",
  CODE34: "+34 西班牙",
  CODE36: "+36 匈牙利",
  CODE39: "+39 義大利",
  CODE40: "+40 羅馬尼亞",
  CODE41: "+41 瑞士",
  CODE43: "+43 奧地利",
  CODE44: "+44 英國",
  CODE45: "+45 丹麥",
  CODE46: "+46 瑞典",
  CODE47: "+47 挪威",
  CODE48: "+48 波蘭",
  CODE49: "+49 德國",
  CODE51: "+51 秘魯",
  CODE52: "+52 墨西哥",
  CODE53: "+53 古巴",
  CODE54: "+54 阿根廷",
  CODE55: "+55 巴西",
  CODE56: "+56 智利 / 復活節島",
  CODE57: "+57 哥倫比亞",
  CODE58: "+58 委內瑞拉",
  CODE60: "+60 馬來西亞",
  CODE61: "+61 澳大利亞",
  CODE62: "+62 印尼",
  CODE63: "+63 菲律賓",
  CODE64: "+64 新西蘭",
  CODE65: "+65 新加坡",
  CODE66: "+66 泰國",
  CODE81: "+81 日本",
  CODE82: "+82 南韓",
  CODE84: "+84 越南",
  CODE90: "+90 土耳其",
  CODE91: "+91 印度",
  CODE92: "+92 巴基斯坦",
  CODE93: "+93 阿富汗",
  CODE94: "+94 斯里蘭卡",
  CODE95: "+95 緬甸",
  CODE98: "+98 伊朗",
  CODE211: "+211 南蘇丹",
  CODE212: "+212 摩洛哥",
  CODE213: "+213 阿爾及利亞",
  CODE216: "+216 突尼西亞",
  CODE218: "+218 利比亞",
  CODE220: "+220 岡比亞",
  CODE221: "+221 塞內加爾",
  CODE222: "+222 毛里塔尼亞",
  CODE223: "+223 馬里",
  CODE224: "+224 幾內亞",
  CODE225: "+225 科特迪瓦",
  CODE226: "+226 布吉納法索",
  CODE227: "+227 尼日爾",
  CODE228: "+228 多哥",
  CODE229: "+229 貝南",
  CODE230: "+230 模里西斯",
  CODE231: "+231 利比里亞",
  CODE232: "+232 塞拉利昂",
  CODE233: "+233 加納",
  CODE234: "+234 奈及利亞",
  CODE235: "+235 乍得",
  CODE236: "+236 中非",
  CODE237: "+237 喀麥隆",
  CODE238: "+238 佛得角",
  CODE239: "+239 聖多美和普林西比",
  CODE240: "+240 赤道幾內亞",
  CODE241: "+241 加彭",
  CODE242: "+242 剛果共和國",
  CODE243: "+243 剛果民主共和國",
  CODE244: "+244 安哥拉",
  CODE245: "+245 幾內亞比紹",
  CODE246: "+246 英屬印度洋領地（英國）",
  CODE247: "+247 阿森松（英國）",
  CODE248: "+248 塞舌爾",
  CODE249: "+249 蘇丹",
  CODE250: "+250 盧旺達",
  CODE251: "+251 衣索比亞",
  CODE252: "+252 索馬里",
  CODE253: "+253 吉布提",
  CODE254: "+254 肯尼亞",
  CODE255: "+255 坦桑尼亞 / 尚吉巴",
  CODE256: "+256 烏干達",
  CODE257: "+257 蒲隆地",
  CODE258: "+258 莫桑比克",
  CODE260: "+260 尚比亞",
  CODE261: "+261 馬達加斯加",
  CODE262: "+262 馬約特 / 留尼汪",
  CODE263: "+263 辛巴威",
  CODE264: "+264 納米比亞",
  CODE265: "+265 馬拉維",
  CODE266: "+266 賴索托",
  CODE267: "+267 博茨瓦納",
  CODE268: "+268 斯威士蘭",
  CODE269: "+269 科摩羅",
  CODE290: "+290 聖海倫娜（英國）",
  CODE291: "+291 厄立特里亞",
  CODE297: "+297 阿魯巴（荷蘭）",
  CODE298: "+298 法羅群島（丹麥）",
  CODE299: "+299 格陵蘭（丹麥）",
  CODE350: "+350 直布羅陀（英國）",
  CODE351: "+351 葡萄牙",
  CODE352: "+352 盧森堡",
  CODE353: "+353 愛爾蘭",
  CODE354: "+354 冰島",
  CODE355: "+355 阿爾巴尼亞",
  CODE356: "+356 馬爾他",
  CODE357: "+357 賽普勒斯",
  CODE358: "+358 芬蘭",
  CODE359: "+359 保加利亞",
  CODE370: "+370 立陶宛",
  CODE371: "+371 拉脫維亞",
  CODE372: "+372 愛沙尼亞",
  CODE373: "+373 摩爾多瓦",
  CODE374: "+374 亞美尼亞",
  CODE375: "+375 白俄羅斯",
  CODE376: "+376 安道爾",
  CODE377: "+377 摩納哥",
  CODE378: "+378 聖馬力諾",
  CODE379: "+379 梵蒂岡",
  CODE380: "+380 烏克蘭",
  CODE381: "+381 塞爾維亞",
  CODE382: "+382 蒙特內哥羅",
  CODE385: "+385 克羅地亞",
  CODE386: "+386 斯洛維尼亞",
  CODE387: "+387 波士尼亞與赫塞哥維納",
  CODE389: "+389 馬其頓",
  CODE420: "+420 捷克",
  CODE421: "+421 斯洛伐克",
  CODE423: "+423 列支敦斯登",
  CODE500: "+500 英國海外領土（英國）",
  CODE501: "+501 伯利茲",
  CODE502: "+502 危地馬拉",
  CODE503: "+503 薩爾瓦多",
  CODE504: "+504 洪都拉斯",
  CODE505: "+505 尼加拉瓜",
  CODE506: "+506 哥斯達黎加",
  CODE507: "+507 巴拿馬",
  CODE508: "+508 聖皮埃爾和密克隆（法國）",
  CODE509: "+509 海地",
  CODE590: "+590 法國海外領土（法國）",
  CODE591: "+591 玻利維亞",
  CODE592: "+592 圭亞那",
  CODE593: "+593 厄瓜多爾",
  CODE594: "+594 法屬圭亞那（法國）",
  CODE595: "+595 巴拉圭",
  CODE596: "+596 法屬安的列斯（法國）",
  CODE597: "+597 蘇里南",
  CODE598: "+598 烏拉圭",
  CODE599: "+599 荷蘭加勒比區（荷蘭）",
  CODE670: "+670 東帝汶",
  CODE672: "+672 澳大利亞海外領土（澳大利亞）",
  CODE673: "+673 汶萊",
  CODE674: "+674 瑙魯",
  CODE675: "+675 巴布亞新幾內亞",
  CODE676: "+676 東加",
  CODE677: "+677 所羅門群島",
  CODE678: "+678 瓦努阿圖",
  CODE679: "+679 斐濟",
  CODE680: "+680 帛琉",
  CODE681: "+681 瓦利斯和富圖納（法國）",
  CODE682: "+682 庫克群島（新西蘭）",
  CODE683: "+683 紐埃（新西蘭）",
  CODE685: "+685 薩摩亞",
  CODE686: "+686 基里巴斯",
  CODE687: "+687 新喀里多尼亞（法國）",
  CODE688: "+688 圖瓦盧",
  CODE689: "+689 法屬玻里尼西亞（法國）",
  CODE690: "+690 托克勞（新西蘭）",
  CODE691: "+691 密克羅尼西亞聯邦",
  CODE692: "+692 馬紹爾群島",
  CODE800: "+800 國際免費電話",
  CODE808: "+808 國際費用分擔業務",
  CODE850: "+850 北韓",
  CODE855: "+855 柬埔寨",
  CODE856: "+856 老撾",
  CODE870: "+870 國際海事衛星組織",
  CODE878: "+878 環球個人通訊服務",
  CODE880: "+880 孟加拉國",
  CODE881: "+881 移動衛星系統",
  CODE882: "+882 國際網絡",
  CODE883: "+883 國際網絡",
  CODE888: "+888 聯合國人權事務協調辦公室",
  CODE960: "+960 馬爾地夫",
  CODE961: "+961 黎巴嫩",
  CODE962: "+962 約旦",
  CODE963: "+963 敘利亞",
  CODE964: "+964 伊拉克",
  CODE965: "+965 科威特",
  CODE966: "+966 沙烏地阿拉伯",
  CODE967: "+967 葉門",
  CODE968: "+968 阿曼",
  CODE970: "+970 巴勒斯坦",
  CODE971: "+971 阿聯酋",
  CODE972: "+972 以色列",
  CODE973: "+973 巴林",
  CODE974: "+974 卡達",
  CODE975: "+975 不丹",
  CODE976: "+976 蒙古國",
  CODE977: "+977 尼泊爾",
  CODE979: "+979 國際額外費用",
  CODE992: "+992 塔吉克",
  CODE993: "+993 土庫曼",
  CODE994: "+994 阿塞拜疆",
  CODE995: "+995 喬治亞",
  CODE996: "+996 吉爾吉斯",
  CODE998: "+998 烏茲別克",
};
